import { render } from "./applicant-header.vue?vue&type=template&id=4e7c8fdc&scoped=true"
import script from "./applicant-header.vue?vue&type=script&lang=js"
export * from "./applicant-header.vue?vue&type=script&lang=js"

import "./applicant-header.vue?vue&type=style&index=0&id=4e7c8fdc&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7c8fdc"]])

export default __exports__